import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { LayoutErrorModule } from './components/layout/layout.module';
import { AccountOpenedComponent } from './containers/account-opened/account-opened.component';
import { AnswersVerifiedComponent } from './containers/answers-verified/answers-verified.component';
import { AttemptsComponent } from './containers/attempts/attempts.component';
import { BridgerInsightComponent } from './containers/bridger-insight/bridger-insight.component';
import { IdleTimeoutComponent } from './containers/idle-timeout/idle-timeout.component';
import { InfoNotLoadedComponent } from './containers/info-not-loaded/info-not-loaded.component';
import { PageNotFoundComponent } from './containers/page-not-found/page-not-found.component';
import { RecaptchaComponent } from './containers/recaptcha/recaptcha.component';
import { TimeOutComponent } from './containers/time-out/time-out.component';
import { WithoutLoanComponent } from './containers/without-loan/without-loan.component';
import { ModalService } from './modal.service';
import { ValidateIdentityComponent } from './containers/validate-identity/validate-identity.component';
import { LayoutErrorCenterModule } from './components/layout-errors-center/layout-errors-center.module';
import { EquifaxQuestionsComponent } from './containers/equifax-questions/equifax-questions.component';
import { WithdrawalAgencyComponent } from './containers/withdrawal-agency/withdrawal-agency.component';
import { ModalLayoutComponent } from '@shared/ui/modal-layout/modal-layout.component';
import { MaterialModule } from '@shared/material/material.module';
import { FacetecVideoModalComponent } from '@shared/information/modal/facetec-video-modal/facetec-video-modal.component';
import { WithoutDpfComponent } from './containers/without-dpf/without-dpf.component';
import { ValidateDocumentComponent } from './containers/validate-document/validate-document.component';
import { ShowAppsComponent } from './containers/show-apps/show-apps.component';
import { DownloadAppQrModalComponent } from '@shared/information/modal/download-app-qr-modal/download-app-qr-modal.component';
import { QRCodeComponent } from 'angularx-qrcode';

@NgModule({
  declarations: [
    AccountOpenedComponent,
    AnswersVerifiedComponent,
    AttemptsComponent,
    IdleTimeoutComponent,
    InfoNotLoadedComponent,
    PageNotFoundComponent,
    BridgerInsightComponent,
    TimeOutComponent,
    RecaptchaComponent,
    ShowAppsComponent,
    WithoutLoanComponent,
    WithoutDpfComponent,
    WithdrawalAgencyComponent,
    ValidateIdentityComponent,
    ValidateDocumentComponent,
    EquifaxQuestionsComponent,
    ModalLayoutComponent,
    FacetecVideoModalComponent,
    DownloadAppQrModalComponent,
  ],
  imports: [
    CommonModule,
    LayoutErrorModule,
    LayoutErrorCenterModule,
    MaterialModule,
    QRCodeComponent,
  ],
  exports: [
    AccountOpenedComponent,
    AnswersVerifiedComponent,
    AttemptsComponent,
    IdleTimeoutComponent,
    InfoNotLoadedComponent,
    PageNotFoundComponent,
    WithoutLoanComponent,
    WithoutDpfComponent,
    WithdrawalAgencyComponent,
  ],
  providers: [ModalService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class ModalModule {}
